import type { CSSProperties, ReactNode } from 'react';
import styles from './KpiBox.module.css';

interface KpiBoxProps {
  label: string;
  icon: ReactNode;
  accent: string;
  feature?: boolean;
  value?: ReactNode;
  unit?: string;
  footer?: ReactNode;
  children?: ReactNode;
}

export const KpiBox = ({
  label,
  icon,
  accent,
  feature = false,
  value,
  unit,
  footer,
  children
}: KpiBoxProps) => {
  const accentStyle = { '--kpi-accent': accent } as CSSProperties;

  return (
    <section className={`${styles.card} ${feature ? styles.feature : ''}`} style={accentStyle}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        <span className={styles.iconBadge} aria-hidden="true">
          {icon}
        </span>
      </div>
      {children ?? (
        <div className={styles.content}>
          <p className={styles.value}>
            {value}
            {unit && <span className={styles.unit}>{unit}</span>}
          </p>
          {footer && <div className={styles.footer}>{footer}</div>}
        </div>
      )}
    </section>
  );
};
